import React from "react";
import "../Css/About.css";

import mainImg from "../assets/about.jpg";
import smallImg from "../assets/abouta.jpg";

const About = () => {
  return (
    <>
      {/* ================= ABOUT SECTION ================= */}
      <section className="abt-intro">
        <div className="abt-container">

          {/* LEFT IMAGE BLOCK */}
          <div className="abt-images">
            <img
              src={mainImg}
              alt="Tanya Maid Service caregiver with a child"
              className="abt-main-img"
            />

            <div className="abt-circle-img">
              <img src={smallImg} alt="Professional maid" />
            </div>

            <div className="abt-badge">
              <strong>8+</strong>
              <span>
                Years of
                <br />
                Trusted Service
              </span>
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="abt-text">
            <span className="abt-tag">About Us</span>

            <h2 className="abt-title">Care for your home, from people you can trust</h2>

            <p className="abt-desc">
              Tanya Maid Service is a premier provider of professional maid
              services. We connect households with skilled, verified and
              trustworthy domestic help to make everyday life easier and
              stress-free.
            </p>

            <ul className="abt-points">
              <li>Experienced babysitters & nannies</li>
              <li>Same-day or express service</li>
              <li>Satisfaction guaranteed</li>
              <li>Pet care & daily assistance</li>
              <li>Reliable & verified staff</li>
              <li>Full-time / part-time maids</li>
            </ul>

            <a href="/about-us" className="abt-btn">More About Us</a>
          </div>

        </div>
      </section>

      {/* ================= INFO CARDS SECTION ================= */}
      <section className="abt-info">
        <div className="abt-info-wrapper">

          <div className="abt-info-card">
            <span className="abt-info-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </span>
            <div className="abt-info-body">
              <h4>Call us for service</h4>
              <p className="abt-info-bold">+91 73043 98067</p>
              <small>Available 24/7 for all our services.</small>
            </div>
          </div>

          <div className="abt-info-card">
            <span className="abt-info-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16v16H4z" />
                <path d="m22 6-10 7L2 6" />
              </svg>
            </span>
            <div className="abt-info-body">
              <h4>Email us anytime</h4>
              <p className="abt-info-bold">info@tanyamaidservice.com</p>
              <small>We reply within one business day.</small>
            </div>
          </div>

          <div className="abt-info-card">
            <span className="abt-info-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </span>
            <div className="abt-info-body">
              <h4>Our address</h4>
              <p className="abt-info-bold">
                Block No. 317, Rajasthan Compound,<br />
                Western Express Highway,<br />
                Near Virwani Industrial Estate,<br />
                Goregaon (E), Mumbai&nbsp;400063
              </p>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default About;